import FormTransfor from './form_transfor.vue';

export default FormTransfor;
